<script setup>
import { computed } from 'vue';
import { resolveColourValue } from '@/Helpers/themeColourResolver';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
    shift: { type: Number, default: 0 },
});

const iconColourHex = computed(() => resolveColourValue(props.row?.content?.iconColour, props.brand, props.shift));
const bgColourHex = computed(() => resolveColourValue(props.row?.content?.bgColour, props.brand, props.shift));
const titleColourHex = computed(() => resolveColourValue(props.row?.content?.titleColour ?? props.row?.content?.iconColour, props.brand, props.shift));

const iconSize = computed(() => props.row?.content?.iconSize || 52);
const iconContainerStyle = computed(() => ({
    width: `${iconSize.value}px`,
    height: `${iconSize.value}px`,
    backgroundColor: bgColourHex.value,
    borderRadius: (props.row?.content?.borderRadius ?? 0) + 'px',
    color: iconColourHex.value,
    boxShadow: props.row?.content?.dropShadow ? '0 4px 12px rgba(0, 0, 0, 0.15)' : 'none',
}));
const iconGlyphStyle = computed(() => ({
    fontSize: `${Math.max(10, Math.round(iconSize.value * 0.38))}px`,
}));

const titleSizeClass = computed(() => props.row?.content?.titleFontSize || 'text-fl-2xl');
const titleStyle = computed(() => {
    const content = props.row?.content || {};
    const style = {
        color: titleColourHex.value,
        fontWeight: content.titleBold === false ? '400' : '900',
        fontStyle: content.titleItalic ? 'italic' : 'normal',
    };
    if (content.titleFont) {
        style.fontFamily = content.titleFont.replace(/_/g, ' ');
    }
    return style;
});
</script>

<template>
    <div v-if="row.content?.icon" class="w-full p-fl-4">
        <div class="flex items-center gap-3">
            <div
                class="flex items-center justify-center shrink-0"
                :style="iconContainerStyle"
            >
                <font-awesome-icon :icon="'fa-light ' + row.content.icon" :style="iconGlyphStyle" />
            </div>
            <span
                v-if="row.content.title"
                class="min-w-0 break-words"
                :class="titleSizeClass"
                :style="titleStyle"
                v-text="row.content.title"
            />
        </div>
    </div>
</template>
